import React, {useState, useEffect} from 'react';
// import { Icon } from 'antd';
import './static/footer.less'
import msgIcon from "../assets/imgs/home/footer/xinxi-7@2x.png"
import phoneIcon from "../assets/imgs/home/footer/组 4471@2x.png"
import clock from "../assets/imgs/home/footer/组 4472@2x.png"
import faceBookIcon from "../assets/imgs/home/footer/组 4473@2x.png"
// import xIcon from "../assets/imgs/home/footer/组 4474@2x.png"
// import youtibeIcon from "../assets/imgs/home/footer/组 4475@2x.png"
import logo from "../assets/imgs/home/footer/组 4443@2x.png"
import downloadIcon from "../assets/imgs/home/footer/下载@2x.png"
import downloadLogo from "../assets/imgs/home/downloadLogo.webp"
import { canGoMarket } from "../utils/tools";
import { downloadClick, getDownloadUrl } from '../utils/common';
import downloadLeft from "../assets/imgs/home/downloadLeft.webp"

import UserAgentConponent from "../components/UserAgentConponent";
import DownloadComponent from "../components/DownloadComponent";


const Footer = ({isMobile}) => {
  const [UserAgentConponentProps, setUserAgentConponentProps] = useState({
    downLoanApkUrl: andro,
  });
  const [andro, setAndro] = useState("");
  const [userAgentVisible, setUserAgentVisible] = useState(false);

  const [showDownloadModal, setShowDownloadModal] = useState(false);
  
  const handleGoDown = () => {
    // setTimeout(() => {
    //   let deviceType = canGoMarket();
    //   if (deviceType) {
    //     setUserAgentConponentProps({
    //       downLoanApkUrl: andro,
    //     });
    //     setUserAgentVisible(true);
    //   } else {
    //     downloadClick();
    //   }
    // }, 1000);
    setShowDownloadModal(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      console.log("window.location.origin: ", window.location);
      try {
        const url = await getDownloadUrl();
        console.log("Download URL: ", url);
        setAndro(url)
      } catch (error) {
        console.error("Error fetching download URL:", error);
      }
    };
    fetchData(); // 调用异步函数
  }, []);


  return (
    <div>
      <div className={isMobile? "footer-mobile" : "footer"}>
        <div className="area">
          <div className="footer-section">
            <div className="customer">
              <h3>Customer Service</h3>
              <div className="customer-selection">
                <img class="icon" src={msgIcon} alt="msgIcon" />
                <span className="text">service@okpeso.com</span>
              </div>
              {/* <div className="customer-selection">
                <img class="icon" src={phoneIcon} />
                <span className="text">0063-9052553180</span>
              </div> */}
              <div className="customer-selection">
                <img class="icon" src={phoneIcon} alt="phoneIcon" />
                <span className="text">Globe：09052553180</span>
              </div>
              <div className="customer-selection">
                <img class="icon" src={phoneIcon} alt="phoneIcon" />
                <span className="text">Smart：09319533595(WhatsApp)</span>
              </div>
              <div className="customer-selection-hidden-smart">
                <img class="icon" src={phoneIcon} alt="phoneIcon" />
                <span className="text">09621546377(VIBER)</span>
              </div>
              <div className="customer-selection">
                <img class="icon" src={clock}  alt="clockIcon"/>
                <span className="text">{/* From Monday to Sunday  */}9:00 AM to 6:00 PM</span>
              </div>
            </div>
          </div>
          <div class="social">
            {!isMobile? <h3>We are in social networks:</h3> : ""}
            <div className="social-links">
              <a
                href="https://www.facebook.com/OKPesoHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={faceBookIcon} alt="faceBookIcon" />
              </a>
              {/* <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={xIcon} alt="xIcon" /> 
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtibeIcon} alt="youtobeIcon" />
              </a> */}
            </div>
          </div>
          {!isMobile? (<div className="logo">
            <img className="logoImg" src={logo} alt="logo" />
            <div className=" download-btn" onClick={()=>handleGoDown()}>
              <div className={'downloadIcon'}>
                <img src={downloadLeft} alt="Downloadimg"></img>
                  Download APP
              </div>
            </div>
          </div>) :""}
        </div>
      {isMobile ? 
      <div onClick={()=>handleGoDown()} className={'downloadIcon mobile-donwload-button'}>
            <img src={downloadLeft} alt="Downloadimg"></img>
              Download APP
          </div>
       : ""}
      </div>
      
       {/* <hr class="centered-line"/> */}
       <div className={isMobile? "company-mobile" : "company"}>
          <p>
            SEC Registrstion : NO.CS201913681 | Certificate Of Authority: NO.3059
          </p>
        </div>

      {/* {userAgentVisible && <UserAgentConponent {...UserAgentConponentProps} />} */}

      {showDownloadModal && <DownloadComponent cancelModal={setShowDownloadModal}/>}

    </div>
  );
};

export default Footer;